import axios from 'axios'

const commons = {
  state: {
    env: null,
    loadingStatus: false,
    pageLoadingStatus: false,
    backupData: null,
    modalInfo: {
      status: false,
      type: 'info',
      title: '',
      subTitle: '',
      content: '',
      btnLink: ''
    },
    creditQuotaInfo: {
      status: false,
      type: '',
      level: 0
    },
    recordPath: ''
  },
  mutations: {
    SET_ENV_DATA (state, data) {
      state.env = data
    },
    SET_LOADING_STATUS (state, status) {
      state.loadingStatus = status
    },
    SET_PAGE_LOADING_STATUS (state, status) {
      state.pageLoadingStatus = status
    },
    BACKUP_DATA (state, obj) {
      state.backupData = obj
    },
    SET_MODAL_STATUS (state, obj) {
      state.modalInfo.status = obj.status
      state.modalInfo.type = (obj.type) ? obj.type : ''
      state.modalInfo.title = (obj.title) ? obj.title : ''
      state.modalInfo.subTitle = (obj.subTitle) ? obj.subTitle : ''
      state.modalInfo.content = (obj.content) ? obj.content : ''
      state.modalInfo.btnLink = (obj.btnLink) ? obj.btnLink : ''
    },
    SET_QUOTA_MODAL_STATUS (state, obj) {
      state.creditQuotaInfo.status = obj.status
      if (obj.type) state.creditQuotaInfo.type = obj.type
      if (obj.level) state.creditQuotaInfo.level = obj.level
    },
    SET_RECORD_PATH (state, path) {
      state.recordPath = path
    }
  },
  actions: {
    errorsHandler ({commit, dispatch}, {params}) {
      if (process.env.NODE_ENV !== 'production') console.log(params)
      commit('SET_LOADING_STATUS', false)
      if (params.response) {
        switch (params.response.status) {
          case 401:
            dispatch('cleanLoginInfo')
            commit('SET_MODAL_STATUS', {status: true, type: 'info', title: 'errors.authKickOut', subTitle: 'errors.over1hr', btnLink: '/login'})
            break
          case 500:
          case 504:
            commit('SET_MODAL_STATUS', {status: true, type: 'error', title: 'errors.serverFail', subTitle: 'errors.serverRetry'})
            break
        }
      } else {
        // timeout
        if (params.toString().indexOf('timeout') !== -1) {
          commit('SET_MODAL_STATUS', {status: true, type: 'error', title: 'errors.serverTimeout', subTitle: 'errors.serverRetry'})
        } else if (params.toString().indexOf('Network Error') !== -1) {
          // no network
          commit('SET_MODAL_STATUS', {status: true, type: 'error', title: 'errors.withoutEthernet', subTitle: 'errors.serverRetry'})
        } else {
          // others
          commit('SET_MODAL_STATUS', {status: true, type: 'error', title: 'errors.unknowFail', subTitle: 'errors.serverRetry'})
        }
      }
    },
    cleanLoginInfo ({commit}) {
      commit('REMOVE_STORE_INFO')
      commit('REMOVE_AUTH_INFO')
      commit('REMOVE_SALES_DATA')
      commit('REMOVE_NOTIFICATION_INFO')
      commit('REMOVE_USERS_DATA')
      commit('REMOVE_GOOGLE_DATA')
      // 全域的通知視窗必須關閉
      commit('SET_QUOTA_MODAL_STATUS', {status: false})
    },
    uploadImg ({commit}, {params}) {
      return new Promise((resolve, reject) => {
        let data = new FormData()
        data.append('image', params.file, params.file.name)
        data.append('key', params.key)
        axios.post('/api/v1/uploadImg', data, {headers: {'Content-Type': 'multipart/form-data'}})
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  },
  getters: {
    getLoadingStatus (state) {
      return state.loadingStatus
    },
    getPageLoadingStatus (state) {
      return state.pageLoadingStatus
    },
    getModalInfoStatus (state) {
      return state.modalInfo
    },
    recoverData (state) {
      return state.backupData
    },
    getEnvParams (state) {
      return state.env
    },
    getCresitQuotaInfoStatus (state) {
      return state.creditQuotaInfo
    },
    getRecordPath (state) {
      return state.recordPath
    }
  }
}

export default commons
